var _path, _g, _g2, _path2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup93(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 86,
    viewBox: "0 0 97 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 93"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.9648 34.2947C39.9648 38.6512 43.7854 42.1827 48.4998 42.1827C53.2142 42.1827 57.0348 38.6512 57.0348 34.2947C57.0348 29.936 53.2142 26.4045 48.4998 26.4045C43.7854 26.4045 39.9648 29.936 39.9648 34.2947Z",
    fill: "#1246AC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1104_1378",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 81,
    height: 40
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3cd4563a88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.88281 0H88.1165V39.1646H8.88281V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1104_1378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48.4996 4.67975C27.5918 4.67975 10.4946 19.7452 9.21452 38.7729C9.16252 38.0121 9.13281 37.2443 9.13281 36.472C9.13281 16.3741 26.7574 0.0849609 48.4996 0.0849609C70.2393 0.0849609 87.8639 16.3741 87.8639 36.472C87.8639 37.2443 87.8367 38.0121 87.7847 38.7729C86.5045 19.7452 69.4074 4.67975 48.4996 4.67975Z",
    fill: "#1246AC"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.4414 24.4474L48.4996 15.3884L67.5578 24.4474L57.7823 25.6345V33.2795H39.2169V25.6345L36.8993 25.3549V30.133C36.8993 30.4951 36.5799 30.7907 36.1887 30.7907C35.795 30.7907 35.478 30.4951 35.478 30.133V25.1807L29.4414 24.4474Z",
    fill: "#1246AC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1104_1378",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 11,
    width: 55,
    height: 75
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "73b8ee2416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.4766 11.5913H96.0386V85.8001H42.4766V11.5913Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1104_1378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M42.7816 75.6981C42.7939 74.6233 42.8385 73.8693 42.8707 73.5645C43.8413 63.8112 47.7238 54.4704 54.0773 46.5527C58.5986 40.9174 71.7687 30.6004 76.399 18.4156C75.5026 27.9352 69.5155 37.0972 62.3449 46.5527C55.0455 56.18 63.2115 73.6814 63.2115 73.6814C79.9868 68.1081 91.9832 53.2718 91.9832 35.846C91.9832 26.9704 88.8684 18.7708 83.5993 12.1204C91.3246 19.9327 96.039 30.3368 96.039 41.7562C96.039 62.3835 80.6627 79.6902 59.9282 84.4225C56.2662 85.2566 52.4382 85.6989 48.4988 85.6989C46.8572 85.6989 45.2378 85.6233 43.6408 85.4743C42.8905 81.5395 42.7593 77.9256 42.7816 75.6981Z",
    fill: "#1246AC"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1104_1378",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 47,
    height: 75
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "d2fcbdda55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0.958984 11.5913H46.9145V85.5113H0.958984V11.5913Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1104_1378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M39.3452 75.666C39.3576 74.5225 39.4072 73.6722 39.4517 73.2597C40.2044 65.6789 42.6235 58.325 46.5308 51.6241C45.4339 49.8779 44.2305 48.1843 42.9207 46.5527C38.3994 40.9174 25.2293 30.6004 20.599 18.4179C21.4954 27.9352 27.4825 37.0972 34.6507 46.5527C41.9525 56.18 33.7865 73.6814 33.7865 73.6814C17.0112 68.1081 5.01476 53.2718 5.01476 35.8483C5.01476 26.9704 8.12964 18.7708 13.3987 12.1204C5.67339 19.9327 0.958984 30.3368 0.958984 41.7562C0.958984 62.3835 16.3353 79.6902 37.0698 84.4225C38.0602 84.647 39.0605 84.8441 40.0757 85.0091C39.4047 81.017 39.3279 77.4902 39.3452 75.666Z",
    fill: "#98B7F4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup93);
export default __webpack_public_path__ + "static/media/Group 93.9fb820b78bebf0cdcd4ebd4b925b881c.svg";
export { ForwardRef as ReactComponent };